import { render, staticRenderFns } from "./MobileEssayList.vue?vue&type=template&id=22c9d856&scoped=true"
import script from "./MobileEssayList.vue?vue&type=script&lang=js"
export * from "./MobileEssayList.vue?vue&type=script&lang=js"
import style0 from "./MobileEssayList.vue?vue&type=style&index=0&id=22c9d856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c9d856",
  null
  
)

export default component.exports